module.exports = __webpack_public_path__ + "img/C6.ee74b5c2.webp";